import axios from 'axios'
import router from '@/router'
import store from '@/store'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  transformResponse: [data => JSON.parse(data).data],
  withCredentials: true,
  headers: { 'App-Name': 'blaze' }
})

let retry = false

axiosInstance.interceptors.request.use(
  config => {
    if (config.url.includes('auth/refresh')) { retry = false }
    return config
  },
  error => error
)

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config
    if (error.response && error.response.status === 401) {
      if (!retry && !originalRequest.url.includes('auth/refresh')) {
        retry = true
        return axiosInstance.post('/auth/refresh')
          .then(() => {
            return axiosInstance(originalRequest)
          })
          .catch(() => {
            store.dispatch('auth/logout')
            router.replace({ name: 'login' })
            return Promise.reject(error)
          })
      } else {
        store.dispatch('auth/logout')
        router.replace({ name: 'login' })
        return Promise.reject(error)
      }

    }
    return Promise.reject(error)
  }
)

export default axiosInstance
